import { SuitableSubstitutesContent } from '@/components/SuitableSubstitutes/SuitableSubstitutesContent';
import { useAssetCompositeSearch } from '@/hooks/api/assets/assetCompositeSearch/useAssetCompositeSearch';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { useSearchFilters } from '@/hooks/useSearchFilters';
import { useTenants } from '@/services/tenants/useTenants';
import { Box, styled } from '@mui/material';

const PageContainer = styled(Box)({
  flex: 1,
  minWidth: '400px',
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
});

const ContentArea = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: '0 6px 6px 0',
  minWidth: 0,
});

export const SuitableSubstitutesPage = () => {
  const { getTenantId } = useTenants();
  const currentTenantId = getTenantId();

  const { searchQuery, selectedFilters, assetId, isEmptySearch } = useSearchFilters();

  const {
    isLoading,
    data: searchData,
    error,
  } = useAssetCompositeSearch({
    assetId,
    tenantId: currentTenantId,
    searchQuery,
    selectedFilters,
    enabled: !!assetId,
  });

  const { permissions } = useGetCurrentUser();

  if (permissions.canOnlySearch && isEmptySearch) {
    return;
  }

  return (
    <PageContainer>
      <ContentArea>
        <SuitableSubstitutesContent isLoading={isLoading} error={error} searchData={searchData} />
      </ContentArea>
    </PageContainer>
  );
};
